import styled from 'styled-components'

export const StyledVolumesQueriesSelection = styled.div``
